<template>
<div class="chapter">
<div class="inner_page">
<div id="a05_copyright">
<p class="copy">Copyright © Arthur J Marder 1978<br/>Introduction copyright © Barry Gough 2014</p>
<p class="copy1">This edition first published in Great Britain in 2014 by<br/>Seaforth Publishing,<br/>Pen &amp; Sword Books Ltd,<br/>47 Church Street,<br/>Barnsley S70 2AS</p>
<p class="copy2"><a href="http://www.seaforthpublishing.com" target="_blank">www.seaforthpublishing.com</a></p>
<p class="copy1">Published and distributed in the<br/>United States of America and Canada by the<br/>Naval Institute Press,<br/>291 Wood Road, Annapolis,<br/>Maryland 21402-5034</p>
<p class="copy2"><a href="http://www.nip.org" target="_blank">www.nip.org</a></p>
<p class="copy1"><i>British Library Cataloguing in Publication Data</i><br/>A catalogue record for this book is available from the British Library</p>
<p class="copy2">Library of Congress Control Number: 2013937405</p>
<p class="copy2">ISBN 978 1 84832 200 4</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or any information storage and retrieval system, without prior permission in writing of both the copyright owner and the above publisher.</p>
<p class="copy2">Printed and bound in Great Britain by CPI Group (UK) Ltd, Croydon, CRO 4YY</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_copyright.vue?228e861a